import { ChangeDetectorRef, Component, Input } from "@angular/core";

import { CalendarDirective, DateRange } from "./calendar.directive";

/**
 * Vattenfall UI Calendar provides the functionality for selecting a date, month or year from a calendar.
 * The calendar outputs a user selected date range depending on the type when creating it. Default calendar type is "day"
 * Usage:
 *  To use a day calendar (i.e to select a single day from a given month)
 *  pass in a Date object as [date] property and listen to (dateChange) event emmiter for date selection.
 *  If [date] input is not passed in - the calendar will display current month with no preselected date.
 * `<ui-calendar [date]="dateObject" (dateChange)="onDateSelect($event)" ></ui-calendar>`
 *
 * To select a range of date:
 *  pass in [type]="'month'" input if you want to select a month or [type]="'year" for year selection.
 *  To mark a pre selected range - pass in a DateRange object via the [dateRange] input.
 *  To receive the range selection from the calendar, subscribe to the (dateRangeChange) output.
 * `<ui-calendar type="month" [dateRange]="dateRangeObject" (dateRangeChange)="onDateSelect($event)" ></ui-calendar>
 */
@Component({
  selector: "ui-calendar",
  templateUrl: "./calendar.component.html",
  host: {
    class: "ds-p-sm ds-block",
  },
})
export class CalendarComponent extends CalendarDirective {
  constructor(public changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }
  @Input()
  override get selected(): DateRange {
    return this._selected;
  }
  override set selected(range: DateRange) {
    this._selected = range;
  }
  override _selected!: DateRange;
}
